module.exports = __webpack_public_path__ + "static/media/diy2.d714599c.png";